<template>
  <div id="app">
    <router-view :key="$route.fullPath" v-if="isRouterAlive"/>
  </div>
</template>
<script>
	export default {
		provide () {
			return{
				reload: this.reload
			}
		},
		data() {
			return {
				common_info: {
					store: {}
				},
				isRouterAlive: true
			};
		},
		methods: {
			getdata(){
				this.$api.store().then((res) => {
					if (res.code == 0) {
						document.title=res.data.store.name;
					}
				})
				.catch((err) => {
					this.common.message(this, err);
				});
			},
			reload(){
				this.isRouterAlive = false
				this.$nextTick(function(){
					this.isRouterAlive = true
				})
			}
		},
		created() {
			let that = this; 
			this.common.getCommonInfo(this,function(){
				/* that.ttshop_name = that.common_info.store.name;
				document.title = that.common_info.store.name; */
				var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
				link.type = "image/x-icon";
				link.rel = "shortcut icon";
				link.href = that.common_info.store.icon;
				document.getElementsByTagName("head")[0].appendChild(link);
				/* let head = document.getElementsByTagName("head");
				let meta = document.createElement("meta");
				document.querySelector('meta[name="keywords"]').setAttribute("content", that.common_info.store.seo_key);
				document.querySelector('meta[name="description"]').setAttribute("content", that.common_info.store.seo_desc); */
			});
			this.getdata();
		},
	};
</script>
<style lang="scss">
</style>
